import PropTypes from 'prop-types'
import React from 'react'

import ButtonScrollDown from 'components/ButtonScrollDown'
import { GOODS_TYPES } from 'constants/sales'
import AddAndGoToCart from 'containers/AddAndGoToCart'
import CostContainerSale from 'containers/CostContainerSale'
import { LocalizationContext } from 'contexts/Localization'
import { MenuMainContext } from 'contexts/MenuMain'
import { Text, H1Small as H1 } from 'styles/components/typography'

import { Article, FirstBlockWrapperStyled, DynamicImageStyled } from './styles'

/**
 * DHowFirst
 *
 * @param {object} props - properties of component
 * @returns {node} DHowFirst
 */
const WHowFirst = props => {
  const { data, secondBlockRef } = props
  const { paths } = React.useContext(LocalizationContext)
  const { isSalesBanner, salesBannerHeight } = React.useContext(MenuMainContext)

  return (
    <FirstBlockWrapperStyled
      isExtraTopIndent={isSalesBanner}
      indentHeight={salesBannerHeight}
      className="pb-2 pb-md-4"
    >
      <div className="row" />

      <div className="row">
        <div className="col-12 col-md-6">
          <Article className="first-content-top-indent">
            <H1 dangerouslySetInnerHTML={{ __html: data.title }} />
            <Text dangerouslySetInnerHTML={{ __html: data.content }} />
          </Article>
          <div className="d-flex align-items-center pt-4">
            <AddAndGoToCart
              goods={[
                {
                  type: GOODS_TYPES.wgs,
                  isSubscription: false,
                },
              ]}
              buttonProps={{
                bgClassName: 'bg--green',
                textClassName: 'text--white',
                withTopMarginOnMobile: true,
              }}
              buttonTitleKey={'order_test'}
              forceMultipleAdd={true}
            />

            <CostContainerSale
              className="ml-15"
              productType={GOODS_TYPES.wgs}
              isMobileCenter={true}
              isWhite={true}
            />
          </div>
        </div>
        <div className="col-12 col-md-6 pt-4 pt-md-0 align-self-center text-center text-md-left">
          <DynamicImageStyled
            alt="wgs-box-right"
            image={`${paths.cdn_boxes}/wgs-right-v2`}
            imageType="png"
            imageSizes={{ xs: 272, md: 613 }}
            className="mt-lg-4"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12 pt-4">
          <ButtonScrollDown
            title={data.go_to_site}
            refToScroll={secondBlockRef}
            isLightColor={true}
          />
        </div>
      </div>
    </FirstBlockWrapperStyled>
  )
}

WHowFirst.propTypes = {
  data: PropTypes.object.isRequired,
  secondBlockRef: PropTypes.object.isRequired,
}

export default WHowFirst
